/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuDisplayPrefsSelect_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly showStrategicPartnerFilter: boolean | null;
    readonly " $refType": "SbSharedRefineMenuDisplayPrefsSelect_user";
};
export type SbSharedRefineMenuDisplayPrefsSelect_user$data = SbSharedRefineMenuDisplayPrefsSelect_user;
export type SbSharedRefineMenuDisplayPrefsSelect_user$key = {
    readonly " $data"?: SbSharedRefineMenuDisplayPrefsSelect_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuDisplayPrefsSelect_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuDisplayPrefsSelect_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isVerifiedTrade",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "showStrategicPartnerFilter",
      "name": "hasPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "STRATEGIC_PARTNER_FILTERING"
        }
      ],
      "storageKey": "hasPermission(name:\"STRATEGIC_PARTNER_FILTERING\")"
    }
  ]
};
(node as any).hash = 'b440e86ba9067ed9193e546d21a8949d';
export default node;
